import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

const useGetStatusList = () => {
    return useQuery({
        queryKey: ['promotion-claim', 'status-list'],
        queryFn: async () => {
            const { data } = await authAxios.get('/api/v1/master-data/status-list');
            return data?.listStatus;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: false,
    });
};

export default useGetStatusList;
